import {Directive, TemplateRef} from '@angular/core'

@Directive({
  selector: '[list-extra-bar]',
  standalone: false,
})
export class FilterListExtraBarDirective {
  constructor(private tpl: TemplateRef<any>) {}
}
